<template>
	<div v-bind:class="'events-' + listFormat()">

		<section>
			<div class="global-container">
				<event-filters v-if="filters.Radius !== undefined && showfilters === true" v-bind:filters="filters"></event-filters>
			</div>
		</section>

		<section id="event-lists" class="padding-top" v-if="listing.length > 0">
			<div class="global-container">

				<div class="upcoming-events">
					<fragment v-if="listFormat() == 'sidebyside'">
						<div v-if="upcoming.length > 0" class="row">
							<div class="col-12">
								<p class="event-lists-heading center">Upcoming Events</p>
							</div>
						</div>
						<div class="row justify-content-center">
							<div v-for="(item, index) in upcomingInitial" v-bind:key="item.DetailID" class="col-6 col-md-3">
								<event-item v-bind:item="item"></event-item>
							</div>
						</div>
					</fragment>

					<div class="row">
						<div v-if="upcoming.length > 8 && upcoming.length != upcomingInitial.length" class="center padding-bottom col-12">
							<button class="btn accent-btn square-btn" type="button" v-on:click="loadMore"><span>Load More</span></button>
						</div>
					</div>
				</div>

				<div class="past-events">
					<div v-if="past.length > 0" class="row">
						<div class="col-12">
							<p class="event-lists-heading center">Past Events</p>
						</div>
					</div>

					<div class="row justify-content-center">
						<div class="col-12">
							<div class="row">
								<div class="past-events-item" v-for="(item, index) in past.slice(0, past.length / 2, past.length)" v-bind:key="item.DetailID">
									<a v-bind:href="item.Url">
										<template v-if="!item.City">
											{{ item.State}}:
											<span v-if="!item.EndDate">
												{{ formatDateRangeAbv(item.StartDate) }}
											</span>
											<span v-else>
												{{ formatDateRangeAbv(item.StartDate, item.EndDate) }}
											</span>
										</template>
										<template v-else>
											{{ item.City}}, {{ item.State}}:
											<span v-if="!item.EndDate">
												{{ formatDateRangeAbv(item.StartDate) }}
											</span>
											<span v-else>
												{{ formatDateRangeAbv(item.StartDate, item.EndDate) }}
											</span>
										</template>
									</a>
								</div>
								<div class="past-events-item" v-for="(item, index) in past.slice(past.length / 2, past.length)" v-bind:key="item.DetailID">
									<a v-bind:href="item.Url">
										<template v-if="!item.City">
											{{ item.State}}:
											<span v-if="!item.EndDate">
												{{ formatDateRangeAbv(item.StartDate) }}
											</span>
											<span v-else>
												{{ formatDateRangeAbv(item.StartDate, item.EndDate) }}
											</span>
										</template>
										<template v-else>
											{{ item.City}}, {{ item.State}}:
											<span v-if="!item.EndDate">
												{{ formatDateRangeAbv(item.StartDate) }}
											</span>
											<span v-else>
												{{ formatDateRangeAbv(item.StartDate, item.EndDate) }}
											</span>
										</template>
									</a>
								</div>
							</div>
						</div>
					</div>
				</div>

			</div>
		</section>

		<section class="padding-top padding-bottom center" v-else>
			<div class="global-container">
				<fragment>
					<h4 class="not-found-heading">Sorry, no results were found matching your specifications.</h4>
					<p>Try removing some filters or searching a different term.</p>
				</fragment>
			</div>
		</section>

	</div>
</template>

<script>
	import { mapState, mapActions, mapMutations } from 'vuex';
	import EventItem from '../components/ffa/summary-item';
	import EventFilters from '../components/event/event-filters';
	import eventListFilter from '../filters/event-list-filter';
	import DateFormatService from '../services/date-format.service';

	export default {
		props: ['filterid',
			'filtertype',
			'result',
			'resource',
			'showfilters',
			'eventstyle',
			'showpastevents'
		],
		data: function () {
			return {
				filters: {},
				upcomingAmount: 8,
				upcomingInitial: []
			}
		},
		computed: mapState({
			loading: state => state.listing.loading,
			listing: state => state.listing.listing,
			specification: state => state.listing.specification,
			upcoming: state => state.listing.listing.filter(event => {
				return event.Upcoming == true
			}),
			past: state => state.listing.listing.filter(event => {
				return event.Upcoming == false
			}),
		}),
		watch: {
			upcoming(newValue, oldValue) {
				this.upcomingInitial = [...newValue.filter(event => {
					return event.Upcoming == true
				}).slice(0, this.upcomingAmount)];
			},
		},
		components: {
			'event-item': EventItem,
			'event-filters': EventFilters
		},
		mounted: function () {
			let _this = this;

			// take props and send to vuex store
			this.setInitData(this.result);
			this.filters = eventListFilter;

			this.$store.subscribeAction((action, state) => {
				if (action.type === 'listing/setFilter') {
					$('html, body').animate({
						scrollTop: $('.filter-app').offset().top
					}, 1000);
				}
			});

			this.$store.subscribeAction((action, state) => {
				if (action.type === 'listing/setEventFilter') {
					$('html, body').animate({
						scrollTop: $('.filter-app').offset().top
					}, 1000);
				}
			});

			// if each spec change should trigger a new api call, use this. else manually call setFilter action on button click
			this.$store.subscribe((mutation, state) => {
				if (
					mutation.type === 'listing/updateSpecification' &&
					(mutation.payload.key !== 'Radius' || (mutation.payload.key === 'Radius' && state.listing.specification.Zipcode !== null && state.listing.specification.Zipcode !== undefined && state.listing.specification.Zipcode !== ''))
				) {
					this.setEventFilter();
				}
			});
		},
		methods: {
			...mapActions('listing', { setEventFilter: 'setEventFilter' }),
			...mapMutations('listing', { setInitData: 'setInitData' }),
			listFormat: function () {
				if (this.eventstyle) {
					return this.eventstyle;
				}
				return 'standard';
			},
			formatDateRangeAbv(start, end) {
				return DateFormatService.formatDateRangeAbv(start, end);
			},
			loadMore() {
				this.upcomingAmount += this.upcomingAmount;
				this.upcomingInitial = [...this.upcoming.slice(0, this.upcomingAmount)];
			}
		},
	}
</script>